import React from 'react';
import { styled } from '@mui/material/styles';
import { FormControlLabel } from '@mui/material';
import theme from '../theme';

const StyledFormControlLabel = styled(FormControlLabel)({
    '&.MuiFormControlLabel-root': {
        padding: 0,
        margin: 0,
    },
    '& .MuiFormControlLabel-label': {
        color: theme.palette.primary.main,
        fontSize: '13px',
        fontWeight: 'bold',
    },
});

export default function CheckboxLabel(props) {
    return (
        <StyledFormControlLabel
            control={props.control}
            label={props.label}
            labelPlacement={props.position}
            value={props.value}
        />
    );
}
